import { DependenciesClient } from "./clients";
import {
  DiamondDependency,
  EventTicketDiamondDependencyPayload,
  GetEventDiamondDependenciesPayload,
  GetTicketDiamondDependenciesPayload,
  ListService,
} from "@/types";

export const DiamondDependenciesService: ListService<DiamondDependency> = {
  async add(entity: DiamondDependency, request) {
    const eventId: string = (
      entity.dependentType === "event" ? entity.dependentId : entity.relatedId
    ) as string;
    const ticketId: number = (
      entity.dependentType === "ticket" ? entity.dependentId : entity.relatedId
    ) as number;

    try {
      const payload: EventTicketDiamondDependencyPayload = {
        dependentId: ticketId,
        relatedId: eventId,
        dependentType: "ticket",
        relatedType: "event",
        dependencyType: "relatedTo",
      };
      return DependenciesClient.post<DiamondDependency>(
        "",
        payload,
        false,
        request
      );
    } catch (error) {
      console.error(error);
      return Promise.reject(undefined);
    }
  },
  async remove(entity: DiamondDependency, request) {
    return DependenciesClient.delete(entity.id, request);
  },
  async all(
    payload:
      | GetTicketDiamondDependenciesPayload
      | GetEventDiamondDependenciesPayload
  ) {
    return await DependenciesClient.get<DiamondDependency[]>(
      `/${payload.entityType}/${payload.entityId}`
    );
  },
};
